var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
const IconCircleColorCheck = (_a) => {
    var { color = '#89C900', width = 25, height = 24, fillOpacity = '1' } = _a, props = __rest(_a, ["color", "width", "height", "fillOpacity"]);
    return (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: width, height: height, fill: "none" }, props),
        React.createElement("rect", { width: width, height: height, x: 0.5, fill: color, rx: 12 }),
        React.createElement("path", { stroke: "#fff", strokeLinecap: "round", strokeWidth: 2, d: "m9 12 1.677 2.097a1 1 0 0 0 1.512.057L17 9" })));
};
export default IconCircleColorCheck;
